import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBarModule } from '@angular/material/snack-bar';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { AvatarModule } from 'ngx-avatar';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { MatRadioModule } from '@angular/material/radio';
import { ChangeDetectorRef } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSliderModule } from '@angular/material/slider';
import { CommonModule } from '@angular/common';
import { ScrollingModule } from '@angular/cdk/scrolling';
import {
  MatAutocompleteModule,
  MatBadgeModule,
  MatBottomSheetModule,
  MatChipsModule,
  MatDividerModule,
  MatExpansionModule,
  MatMenuModule,
  MatProgressBarModule,
  MatRippleModule,
  MatSortModule,
  MatStepperModule,
  MatTabsModule,
  MatTooltipModule,
  MatTreeModule
} from '@angular/material';
import { RouterModule } from '@angular/router';
import { AppRoutingModule } from '../../src/app/model/routes';
import { UsersTabComponent } from '../../src/app/model/users.component';
import { RegistriesTabComponent } from '../../src/app/model/registries.component';
import { CallStatusTabComponent } from '../../src/app/model/callStatusComplete';
import { CallDashboardComponent } from './view/pages/calldashboard/dashboard.component';
import { MobileComponent } from './view/pages/mobile/mobile.component';
import { DayMobileComponent } from './view/pages/mobile/day_mobile.component';
import { MonthMobileComponent } from './view/pages/mobile/month_mobile.component';

import { AvailabilitiesInt } from './view/pages/mobile/mobile.component';
import { AvailabilitiesIntD } from './view/pages/mobile/day_mobile.component';
import { AvailabilitiesIntM } from './view/pages/mobile/month_mobile.component';


import { AlarmTabComponent } from '../../src/app/model/alarm.component';
import { ConfirmAlertComponent } from './view/components/confirm-alert/confirm-alert.component';
import { EmergenciesstatusInt } from './view/pages/mobile/mobile.component';
import { MonthEmergenciesstatusInt } from './view/pages/mobile/month_mobile.component';
import { DayEmergenciesstatusInt } from './view/pages/mobile/day_mobile.component';

import { CallstatusInt } from './view/pages/mobile/mobile.component';
import { SettingsTabComponent } from '../../src/app/model/settings.component';
import { MobileTabComponent } from '../../src/app/model/mobile';
import { MonthCallstatusInt } from './view/pages/mobile/month_mobile.component';
import { DayCallstatusInt } from './view/pages/mobile/day_mobile.component';
import { Enti } from '../../src/app/model/mobile';
import { EnteNuovo } from '../../src/app/model/mobile';
import { GruppoNuovo } from '../../src/app/model/mobile';
import { ReperibileNuovo } from '../../src/app/model/mobile';
import { ImpiantoNuovo } from '../../src/app/model/mobile';
import { EccezioneNuovo } from '../../src/app/model/mobile';
import { CodiceNuovo } from '../../src/app/model/mobile';

import { Gruppi } from '../../src/app/model/mobile';
import { Reperibili } from '../../src/app/model/mobile';
import { Impianti } from '../../src/app/model/mobile';
import { EccezioniReperibili } from '../../src/app/model/mobile';
import { CodiciAllarmi } from '../../src/app/model/mobile';


import { AppComponent } from './app.component';
import { CalendarHeaderComponent } from './view/pages/dashboard/scheduler/header';
import { CustomDateFormatter } from './view/pages/dashboard/scheduler/custom';
import { Available } from './view/pages/dashboard/scheduler/scheduler.component';
import { SchedulerInt } from './view/pages/dashboard/scheduler/scheduler.component';


import { OnoButtonComponent } from './view/components/ono-button/ono-button.component';

import { Upload } from './view/pages/dashboard/event-form/event-form.component';
import { Upload2 } from './view/pages/alarmcodes/alarmcodes-edit/alarmcodes-edit.component';
import { Upload3 } from './view/pages/availables/availables-edit/availables-edit.component';
import { Upload4 } from './view/pages/exceptions/exceptions-edit/exceptions-edit.component';
import { Upload5 } from './view/pages/groups/groups-edit/groups-edit.component';
import { Upload6 } from './view/pages/plants/plants-edit/plants-edit.component';
import { Upload7 } from './view/pages/body/body-edit/body-edit.component';

import { CalendarModule, DateAdapter } from 'angular-calendar';
import { adapterFactory } from 'angular-calendar/date-adapters/date-fns';
import localeIt from '@angular/common/locales/it';
import { registerLocaleData } from '@angular/common';
import {
  CalendarDateFormatter,
  CalendarMomentDateFormatter,
  MOMENT,
} from 'angular-calendar';
registerLocaleData(localeIt);

//@ts-ignore

import moment from 'moment-timezone';
import { EventFormComponent } from './view/pages/dashboard/event-form/event-form.component';
import { SchedulerComponent } from './view/pages/dashboard/scheduler/scheduler.component';
import { EventFormMobileComponent } from './view/pages/dashboard/event-form/event-form-mobile.component';


import { UtilsService } from './service/helper/utils.service';
import { BasicAuthInterceptor } from './helpers/basic-auth.interceptor';
import { ErrorInterceptor } from './helpers/error.interceptor';
import { HeaderComponent } from './view/components/layout/header/header.component';
import { FooterComponent } from './view/components/layout/footer/footer.component';
import { Footer2Component } from './view/components/layout/footer2/footer2.component';

import { ApiService } from './service/api.service';
import { AuthenticationService } from './service/authentication.service';
import { SideBarComponent } from './view/components/layout/side-bar/side-bar.component';
import { Send } from './view/components/layout/side-bar/side-bar.component';

import { RegisterComponent } from './view/pages/users/register/register.component';
import { LoginComponent } from './view/pages/login/login.component';
import { Recov } from './view/pages/login/login.component';

// import { UsersListComponent } from './view/pages/users/users-list/users-list.component';
import { PersonalDataComponent } from './view/pages/personalData/personaldata.component';
import { CurrentUserService } from './service/current-user.service';

import { SafePipe } from './view/pages/dashboard/safe.pipe';
import { DashboardComponent } from './view/pages/dashboard/dashboard.component';
import { DashboardComponent2 } from './view/pages/otherdash/dashboard.component';

import { UsersComponent } from './view/pages/usersnew/users.component';
import { UsersListComponent } from './view/pages/usersnew/users-list/users-list.component';
import { UsersEditComponent } from './view/pages/usersnew/users-edit/users-edit.component';
import { UsersService } from './view/pages/usersnew/users.service';
import { SchedulerService } from './view/pages/dashboard/scheduler.service';


import { GroupsComponent } from './view/pages/groups/groups.component';
import { GroupsListComponent } from './view/pages/groups/groups-list/groups-list.component';
import { GroupsEditComponent } from './view/pages/groups/groups-edit/groups-edit.component';
import { GroupsService } from './view/pages/groups/groups.service';

import { AvailablesComponent } from './view/pages/availables/availables.component';
import { AvailablesListComponent } from './view/pages/availables/availables-list/availables-list.component';
import { AvailablesEditComponent } from './view/pages/availables/availables-edit/availables-edit.component';
import { AvailablesService } from './view/pages/availables/availables.service';

import { AlarmcodesComponent } from './view/pages/alarmcodes/alarmcodes.component';
import { AlarmcodesListComponent } from './view/pages/alarmcodes/alarmcodes-list/alarmcodes-list.component';
import { AlarmcodesEditComponent } from './view/pages/alarmcodes/alarmcodes-edit/alarmcodes-edit.component';
import { AlarmcodesService } from './view/pages/alarmcodes/alarmcodes.service';

import { ExceptionsComponent } from './view/pages/exceptions/exceptions.component';
import { ExceptionsListComponent } from './view/pages/exceptions/exceptions-list/exceptions-list.component';
import { ExceptionsEditComponent } from './view/pages/exceptions/exceptions-edit/exceptions-edit.component';
import { ExceptionsService } from './view/pages/exceptions/exceptions.service';

import { PlantsComponent } from './view/pages/plants/plants.component';
import { PlantsListComponent } from './view/pages/plants/plants-list/plants-list.component';
import { PlantsEditComponent } from './view/pages/plants/plants-edit/plants-edit.component';
import { PlantsService } from './view/pages/plants/plants.service';
import { TtsComponent } from './view/pages/tts/tts.component';
import { EmailComponent } from './view/pages/email/email.component';

import { CallstatusComponent } from './view/pages/callstatus/callstatus.component';
import { EmergenciesstatusComponent } from './view/pages/emergenciesstatus/emergenciesstatus.component';
import { EmergenciesnotmanagedComponent } from './view/pages/emergenciesnotmanaged/emergenciesnotmanaged.component';
import { TtsService } from './view/pages/tts/tts.service';
import { EmailService } from './view/pages/email/email.service';

import { CallstatusService } from './view/pages/callstatus/callstatus.service';
import { EmergenciesstatusService } from './view/pages/emergenciesstatus/emergenciesstatus.service';
import { EmergenciesnotmanagedService } from './view/pages/emergenciesnotmanaged/emergenciesnotmanaged.service';

import { BodyComponent } from './view/pages/body/body.component';
import { BodyListComponent } from './view/pages/body/body-list/body-list.component';
import { BodyEditComponent } from './view/pages/body/body-edit/body-edit.component';
import { BodyService } from './view/pages/body/body.service';

import { SettingsComponent } from './view/pages/settings/settings.component';
import { TtssettingsComponent } from './view/pages/ttssettings/ttssettings.component';
import { BackupComponent } from './view/pages/backup/backup';
import { BackupService } from './view/pages/backup/backup.service';

import { TtssettingsService } from './view/pages/ttssettings/ttssettings.service';

import { SettingsService } from './view/pages/settings/settings.service';
import { Edit } from './view/pages/settings/settings.component';
import { Edittts } from './view/pages/ttssettings/ttssettings.component';

import { EditBackup } from './view/pages/backup/backup';


export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

@NgModule({
  declarations: [
    OnoButtonComponent,
    ConfirmAlertComponent,
    EventFormComponent, EventFormMobileComponent,
    SchedulerComponent,
    SafePipe,
    HeaderComponent,
    FooterComponent,
    Footer2Component,
    CalendarHeaderComponent,
    Edit, Edittts,EditBackup,
    UsersComponent,
    UsersListComponent,
    UsersEditComponent,

    DashboardComponent,
    DashboardComponent2,
    AppComponent,
    SideBarComponent,
    Send,
    LoginComponent,
    PersonalDataComponent,
    GroupsEditComponent,
    AvailablesEditComponent,
    AlarmcodesEditComponent,
    ExceptionsEditComponent,
    PlantsEditComponent,
    BodyEditComponent,
    GroupsComponent,
    GroupsListComponent,
    Recov,
    PlantsComponent,
    BodyComponent,
    PlantsListComponent,
    BodyListComponent,
    CallstatusComponent,
    TtsComponent,
    EmailComponent,
    EmergenciesstatusComponent,
    EmergenciesnotmanagedComponent,
    CallDashboardComponent,
    MobileComponent,
    DayMobileComponent,
    MonthMobileComponent,
    AvailabilitiesInt,
    AvailabilitiesIntD,
    AvailabilitiesIntM,
    SettingsComponent,BackupComponent,
    TtssettingsComponent,
    EmergenciesstatusInt,
    MonthEmergenciesstatusInt,
    Enti, EnteNuovo, GruppoNuovo,
    ReperibileNuovo,
    ImpiantoNuovo,
    EccezioneNuovo,
    CodiceNuovo,
    Gruppi,
    Reperibili,
    Impianti,
    EccezioniReperibili,
    CodiciAllarmi,
    DayEmergenciesstatusInt,
    CallstatusInt,
    MonthCallstatusInt,
    DayCallstatusInt,
    ExceptionsComponent,
    ExceptionsListComponent,

    AlarmcodesComponent,
    AlarmcodesListComponent,

    AvailablesComponent,
    AvailablesListComponent,

    RegisterComponent,

    UsersTabComponent,

    Available,
    Upload,
    Upload2, SchedulerInt,
    Upload3,
    Upload4,
    Upload5,
    Upload6,
    Upload7,
    MobileTabComponent,
    AlarmTabComponent,
    SettingsTabComponent,
    RegistriesTabComponent,
    CallStatusTabComponent

  ],
  imports: [
    CalendarModule.forRoot(
      {
        provide: DateAdapter,
        useFactory: adapterFactory,
      },
      {
        dateFormatter: {
          provide: CalendarDateFormatter,
          useClass: CustomDateFormatter,
        },
      }
    ),
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,

    MatFormFieldModule,
    CommonModule,
    HttpClientModule,
    BrowserModule,
    BrowserAnimationsModule,
    MatAutocompleteModule,
    MatBadgeModule,
    MatBottomSheetModule,
    MatButtonModule,
    MatButtonToggleModule,
    MatCardModule,
    MatCheckboxModule,
    MatChipsModule,
    MatDatepickerModule,
    MatDialogModule,
    MatDividerModule,
    MatExpansionModule,
    MatGridListModule,
    MatIconModule,
    MatInputModule,
    MatListModule,
    MatMenuModule,
    MatNativeDateModule,
    MatPaginatorModule,
    MatProgressBarModule,
    MatProgressSpinnerModule,
    MatRadioModule,
    MatRippleModule,
    MatSelectModule,
    MatSidenavModule,
    MatSliderModule,
    MatSlideToggleModule,
    MatSnackBarModule,
    MatSortModule,
    MatStepperModule,
    MatTableModule,
    MatTabsModule,
    MatToolbarModule,
    MatTooltipModule,
    MatTreeModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    MatRadioModule,
    BrowserModule,
    AppRoutingModule,
    DragDropModule,
    BrowserAnimationsModule,
    FormsModule,
    MatFormFieldModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatSliderModule,
    MatSnackBarModule,
    CommonModule,
    ScrollingModule,
    HttpClientModule,
    BrowserModule,
    MatCardModule,
    MatButtonModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    MatInputModule,
    MatToolbarModule,
    MatCheckboxModule,
    MatSidenavModule,
    HttpClientModule,
    MatSnackBarModule,
    MatProgressSpinnerModule,
    MatFormFieldModule,
    FormsModule,
    MatGridListModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MatIconModule,
    MatListModule,
    MatTableModule,
    AvatarModule,
    MatDatepickerModule,
    MatNativeDateModule,
    NgxUiLoaderModule,
    MatPaginatorModule,
    MatDialogModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatButtonToggleModule,
  ],
  //@ts-ignore
  providers: [
    EventFormComponent, EventFormMobileComponent,
    SchedulerComponent,
    SafePipe,
    HeaderComponent,
    FooterComponent,
    Footer2Component,
    CalendarHeaderComponent,
    Edit, Edittts,EditBackup,
    UsersComponent,
    UsersListComponent,
    UsersEditComponent,

    DashboardComponent,
    DashboardComponent2,
    AppComponent,
    SideBarComponent,
    Send,
    LoginComponent,
    PersonalDataComponent,
    GroupsEditComponent,
    AvailablesEditComponent,
    AlarmcodesEditComponent,
    ExceptionsEditComponent,
    PlantsEditComponent,
    BodyEditComponent,
    GroupsComponent,
    GroupsListComponent,
    Recov,
    PlantsComponent,
    PlantsListComponent,
    BodyListComponent,
    CallstatusComponent,
    TtsComponent,
    EmailComponent,
    CallDashboardComponent,
    EmergenciesstatusComponent,
    EmergenciesnotmanagedComponent,
    SettingsComponent,BackupComponent,
    TtssettingsComponent,
    MobileComponent,
    DayMobileComponent,
    MonthMobileComponent,
    AvailabilitiesInt,
    AvailabilitiesIntD,
    AvailabilitiesIntM,
    ExceptionsComponent,
    ExceptionsListComponent,
    EmergenciesstatusInt,
    MonthEmergenciesstatusInt,
    Enti, EnteNuovo, GruppoNuovo,
    ReperibileNuovo,
    ImpiantoNuovo,
    EccezioneNuovo,
    CodiceNuovo,
    Gruppi,
    Reperibili,
    Impianti,
    EccezioniReperibili,
    CodiciAllarmi,
    DayEmergenciesstatusInt,
    CallstatusInt,
    MonthCallstatusInt,
    DayCallstatusInt,
    AlarmcodesComponent,
    AlarmcodesListComponent,

    AvailablesComponent,
    AvailablesListComponent,

    RegisterComponent,

    UsersTabComponent,

    Available,
    Upload,
    Upload2, SchedulerInt,
    Upload3,
    Upload4,
    Upload5,
    Upload6,
    Upload7,
    MobileTabComponent,
    AlarmTabComponent,
    SettingsTabComponent,
    RegistriesTabComponent,
    CallStatusTabComponent,

    //@ts-ignore
    ChangeDetectorRef,
    AuthenticationService,
    ApiService,
    CurrentUserService,
    SchedulerService,
    UsersService,
    GroupsService,
    AvailablesService,
    AlarmcodesService,
    ExceptionsService,
    PlantsService,
    BodyService,BackupService,
    SettingsService,
    TtssettingsService,
    TtsService,
    EmailService,
    CallstatusService,
    EmergenciesstatusService,
    EmergenciesnotmanagedService,
    UtilsService,
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: BasicAuthInterceptor, multi: true },
    { provide: LocationStrategy, useClass: HashLocationStrategy },
    {
      provide: MAT_SNACK_BAR_DEFAULT_OPTIONS, useValue: {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center'
      }
    },
  ],
  entryComponents: [Recov, Available, Upload, Upload2, SchedulerInt, Send,
    Upload3,
    Upload4,
    Upload5,
    Upload6,
    Upload7, Edit, EditBackup, ConfirmAlertComponent, EmergenciesstatusInt, MonthEmergenciesstatusInt, Enti, EnteNuovo, Gruppi, GruppoNuovo, AvailabilitiesInt,
    AvailabilitiesIntD,
    AvailabilitiesIntM,
    ReperibileNuovo,
    ImpiantoNuovo,EventFormMobileComponent,
    EccezioneNuovo,
    CodiceNuovo,
    Reperibili,
    Impianti,
    EccezioniReperibili,
    CodiciAllarmi,
    DayEmergenciesstatusInt, CallstatusInt,
    MonthCallstatusInt,
    DayCallstatusInt, Edittts
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
